import { isScrolledIntoView } from 'utils/view';

interface AnchorLinksProps {
    el: HTMLDivElement;
}

// Run the functions on document ready
const AnchorLinks = ({ el }: AnchorLinksProps): void => {
    const anchorLink = el;
    const anchorLinkHeader = anchorLink.querySelector('.anchor-links-header') as HTMLElement;
    const anchorLinkList = anchorLink.querySelector('.anchor-links-list') as HTMLElement;
    const anchorLinkListContent = anchorLink.querySelector('.anchor-links-list-content') as HTMLElement;
    const anchorLinksItems = anchorLink.querySelectorAll('.anchor-links-item') as NodeListOf<HTMLElement>;
    const stickyAnchorLink = anchorLink.querySelector('.anchor-links-sticky') as HTMLElement;
    const anchorLinkPlaceholder = anchorLink.querySelector('.anchor-links-placeholder') as HTMLElement;
    const anchorLinkContent = stickyAnchorLink.querySelector('.container') as HTMLElement;

    let initAnchorLinksPos = anchorLink.getBoundingClientRect();
    let initScrollPos = window.scrollY;

    anchorLinkPlaceholder.appendChild(anchorLinkContent.cloneNode(true));

    const linkTitles: Record<string, string> = {};

    anchorLinksItems?.forEach(item => {
        const linkItem = item as HTMLAnchorElement;
        const hash = linkItem.hash.replace('#', '');
        const targetSection = document.getElementById(hash);

        if (hash && !(hash in linkTitles) && targetSection) {
            linkTitles[hash] = linkItem.querySelector('span')?.innerHTML ?? '';
        }

        item.addEventListener('click', e => {
            e.preventDefault();

            const sectionPos = targetSection?.getBoundingClientRect().top;
            const currentStickyAnchorLink = anchorLink.querySelector('.anchor-links-sticky');
            const offset = currentStickyAnchorLink?.clientHeight ?? 0;

            if (sectionPos) {
                const scrollPos = sectionPos + window.scrollY - offset;

                window.scrollTo({
                    top: scrollPos,
                    behavior: 'smooth',
                });
            }
        });
    });

    let sectionInView = '';

    window.addEventListener('scroll', () => {
        const activeLinkTitle = stickyAnchorLink.querySelector('.anchor-links-active-link');
        const isSticky = !!initAnchorLinksPos && window.scrollY >= (initAnchorLinksPos.top + (anchorLinkPlaceholder.clientHeight - anchorLinkHeader.clientHeight) + initScrollPos);

        stickyAnchorLink.classList.toggle('is-pinned', isSticky && !!activeLinkTitle?.innerHTML);

        Object.keys(linkTitles).forEach(key => {
            const section = document.getElementById(key);

            if (activeLinkTitle) {
                if (section && isScrolledIntoView(section, stickyAnchorLink.clientHeight) && sectionInView !== key) {
                    sectionInView = key;

                    activeLinkTitle.innerHTML = linkTitles[key];
                }
            }
        });
    });

    anchorLinkHeader?.addEventListener('click', () => {
        stickyAnchorLink.classList.toggle('is-expanded');
        if (stickyAnchorLink.classList.contains('is-expanded') && stickyAnchorLink.classList.contains('is-pinned')) {
            anchorLinkList.style.height = `${anchorLinkListContent.offsetHeight}px`;
        } else {
            anchorLinkList.style.height = '0';
        }
    });

    window.addEventListener('resize', () => {
        initScrollPos = window.scrollY;
        initAnchorLinksPos = anchorLink.getBoundingClientRect();

        if (stickyAnchorLink.classList.contains('is-expanded')) {
            anchorLinkHeader?.click();
        }
    });
};

export default AnchorLinks;
